import React from "react";
import { useTranslation } from "react-i18next";
import { PushNotification } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import PushNotificationForm from "../PushNotificationForm";

type Props = {
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: PushNotification) => void;
};

const PushNotificationModal: React.FC<Props> = ({
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {t("components.screenPushNotifications.pushNotificationsModal.new")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <PushNotificationForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => onSubmit(data)}
          onCancel={onClose}
        />
      </ModalBody>
    </Modal>
  );
};

export default PushNotificationModal;
